import { Notification, Form, Heading } from '../../components';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { beablooApi } from '../../utils';
import { useState } from 'react';
import { updateOptionCategory } from '../../store/actions/optionCategories';
import addPending from '../../utils/addPending';
import removePending from '../../utils/removePending';
import { addNotification } from '../../utils';

const EditOptionCategory = () => {
  const navigate = useNavigate();

  const { developmentId, categoryId } = useParams();
  const optionCategories = useSelector((state) => state.optionCategories);
  const optionCategory = optionCategories.find(
    (type) => `${type.id}` === categoryId,
  );
  const [error, setError] = useState({ error: false, message: '' });
  const [saved, setSaved] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [saving, setSaving] = useState(false);

  // const socket = useSocket();
  const dispatch = useDispatch();

  const handleSubmit = async (data) => {
    setSaving(true);
    let pendingId = addPending('Saving...');

    const payload = {};

    if (data.name) payload.name = data.name;
    if (data.thumbnail && data.thumbnail.length > 0)
      payload.thumbnail = data.thumbnail;

    await beablooApi({
      method: 'PUT',
      route: `/developments/${developmentId}/optionCategories/${categoryId}/update`,
      payload: payload,
    }).then((r) => {
      removePending(pendingId);
      if (!r.success) {
        setSaving(false);
        setError({ error: true, message: r.message });
      } else {
        // plot saved
        setSaving(false); // stop loading animation
        dispatch(updateOptionCategory({ ...r.data, belongsTo: developmentId })); // add the plot to state
        addNotification('Option Category Updated');
        navigate(`/developments/${developmentId}/optionsOverview`);
        // socket.emit('optionCategory:create', { room: developmentId, payload: r.data });  // emit the the new plot to anyone looking at currentDevelopment.id
        setSaved(true); // tell state to redirect
      }
    });
  };

  return (
    <div className='create-option page-padding'>
      {error.error ? (
        <Notification
          message={error.message}
          removeElement={(e) => setError({ error: false, message: '' })}
        />
      ) : (
        <></>
      )}

      <Heading
        label={`edit an option category: ${
          optionCategory ? optionCategory.name : ''
        }`}
      />

      <Form
        inputs={[
          {
            name: 'name',
            type: 'text',
            label: 'name',
            placeholder: 'Category Name',
            initialValue: optionCategory.name,
          },
          {
            name: 'thumbnail',
            type: 'single-image',
            label: 'thumbnail',
            initialValue: optionCategory.thumbnail,
          },
        ]}
        onSubmit={handleSubmit}
        canSubmit={!saving}
      />
    </div>
  );
};

export default EditOptionCategory;
